export default __webpack_public_path__ + "static/media/comprehensive-banner.3c38a11f.png";